import create from './createAction'

export const GET_LANDING_PAGE = 'GET_LANDING_PAGE'
export const SET_LANDING_PAGE = 'SET_LANDING_PAGE'
export const GET_LANDING_PAGE_ERROR = 'GET_LANDING_PAGE_ERROR'
export const SET_LANDING_PAGE_SUBDOMAIN = 'SET_LANDING_PAGE_SUBDOMAIN'

export const getLandingPage = create(GET_LANDING_PAGE)
export const setLandingPage = create(SET_LANDING_PAGE)
export const getLandingPageError = create(GET_LANDING_PAGE_ERROR)
export const setLandingPageSubdomain = create(SET_LANDING_PAGE_SUBDOMAIN)
